<template>
    <div class="center_order_box">
        <!-- 标题 -->
        <center-title>{{$t("message.corder.title")}}</center-title>
        <!-- 标签页 -->
        <order-search
            :tabs="tabs"
            :handle-download="handleOrderExcel"
			handle="index/orderstatus/order_excel"
            @handle-search="getData">
        </order-search>
        <!-- 列表部分 -->
        <order-manage-list></order-manage-list>
        <!-- 模态框 -->
        <order-manage-dialog></order-manage-dialog>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
    data() {
        return {
            tabs: [ // 标签页参数
                {
                    label: this.$t("message.corder.tabs1"),
                    name: "9",
                },
                // {
                //     label: this.$t("message.corder.tabs2"),
                //     name: "0",
                // },
                // {
                //     label: this.$t("message.corder.tabs3"),
                //     name: "1",
                // },
                // {
                //     label: this.$t("message.corder.tabs4"),
                //     name: "2",
                // },
                // {
                //     label: this.$t("message.corder.tabs5"),
                //     name: "3",
                // },
                {
                    label: this.$t("message.corder.tabs6"),
                    name: "4",
                },
                {
                    label: this.$t("message.corder.tabs7"),
                    name: "5",
                },
                {
                    label: this.$t("message.corder.tabs8"),
                    name: "6",
                },
                {
                    label: this.$t("message.corder.tabs9"),
                    name: "7",
                },
                {
                    label: this.$t("message.corder.tabs10"),
                    name: "8",
                },
            ]
        }
    },
    computed: mapState({
        power: state => state.user.power,
        character_id: state => state.user.character_id,
        islogin: state => state.user.islogin
    }),
    components: {
        centerTitle: () => import("@/components/center/centerTitle"),
        orderSearch: () => import("@/components/center/orderSearch"),
        orderManageList: () => import("@/components/center/orderManageList"),
        orderManageDialog: () => import("@/components/center/orderManageDialog"),
    },
    methods: {
        ...mapMutations([
            "setOrderTabs"
        ]),
        ...mapActions([
            "getOrderList",
            "getOrderDepartment",
            "handleOrderExcel"
        ]),
        getData() {
            let order_sn = sessionStorage.getItem('order_sn') || '',
                release = sessionStorage.getItem('release') || '',
                relend = sessionStorage.getItem('relend') || '',
                department = sessionStorage.getItem('department') || '',
                user_id = sessionStorage.getItem('member') || '';

            this.getOrderDepartment();
            this.getOrderList({
                order_sn,
                release,
                relend,
                department,
                user_id
            })
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
			// && vm.character_id !== 5
            // let allow = vm.character_id !== 3  && vm.character_id !== 6;
			setTimeout(() => {
				let allow = vm.power.includes(0) || vm.power.includes(13) || vm.power.includes(111)
				
				if(allow){
				    vm.getData()
				}else{
				    vm.$router.back();
				    return false;
				}
			}, 500)
        })
    },
    beforeRouteLeave (to, from, next) {
        this.setOrderTabs("9");
        sessionStorage.removeItem("order_tabs");
        sessionStorage.removeItem("order_sn");
        sessionStorage.removeItem("release");
        sessionStorage.removeItem("relend");
        sessionStorage.removeItem("department");
        sessionStorage.removeItem("member");
        next();
    }
}
</script>